import React, { useEffect, useState } from 'react'
import {
  Center,
  HStack,
  Switch,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react'
import UnderlineHeading from '../../components/UnderlineText/UnderlineHeading'
import { REPOSITORY } from './../../api/repository/Repository'
import Alert from './Alert'

export default function Alerts() {
  const [defaultAlerts, setDefaultAlerts] = useState([])
  const [activeAlerts, setActiveAlerts] = useState([])
  const {
    isOpen: isChecked,
    onToggle,
    onClose: handleCancelAutomatic,
    onOpen: handleAllowAutomatic,
  } = useDisclosure()

  useEffect(() => {
    const getAutomaticEnroll = async () => {
      await REPOSITORY.wsEmpresa.company.getAutomaticEnroll().then((res) => {
        if (res.data) {
          handleAllowAutomatic()
        } else {
          handleCancelAutomatic()
        }
      })
    }
    getAutomaticEnroll()
  }, [])
  const handleToggleAutomatic = async () => {
    await REPOSITORY.wsEmpresa.company
      .postConfigAutomaticNN(!isChecked)
      .then(() => {
        onToggle()
      })
  }

  const fetchDefaultAlerts = async () => {
    await REPOSITORY.wsEmpresa.company.getDefaultAlerts().then((res) => {
      setDefaultAlerts(res.data)
    })
  }
  const fetchActiveAlerts = async () => {
    await REPOSITORY.wsEmpresa.company.getActiveAlerts().then((res) => {
      const data = res.data
      const formatted = data.reduce((acc, el) => {
        return { ...acc, [el.idAlerta]: { ...el } }
      }, {})
      setActiveAlerts(formatted)
    })
  }
  useEffect(() => {
    fetchDefaultAlerts()
    fetchActiveAlerts()
  }, [])

  return (
    <Center w="100%">
      <Center
        boxShadow="-7px 7px 34px rgba(0, 0, 0, 0.25)"
        w="90%"
        px="40px"
        pt="30px"
        pb="50px"
        mb="100px"
      >
        <VStack w="100%" alignItems="flex-start" spacing="30px">
          <UnderlineHeading text="Bolsillos" variant="h5" />
          <HStack w="98%" justifyContent="space-between">
            <Text>Activación de bolsillo automática</Text>
            <Switch isChecked={isChecked} onChange={handleToggleAutomatic} />
          </HStack>
          <VStack w="100%" alignItems="flex-start">
            <UnderlineHeading text="Alertas" variant="h5" />
            {defaultAlerts.map((element, index) => (
              <Alert
                index={index}
                key={element.idAlerta}
                title={element.sMensaje}
                // handleOpenConfirmation={handleOpenConfirmation}
                alertId={element.idAlerta}
                baseAlert={element}
                lenght={defaultAlerts.length}
                lVariables={element.lVariables}
                activeAlert={activeAlerts[element.idAlerta]}
                fetchActiveAlerts={fetchActiveAlerts}
              />
            ))}
          </VStack>
        </VStack>
      </Center>
    </Center>
  )
}
